import * as React from "react";
import './casts.scss';
import {Link, graphql, useStaticQuery} from "gatsby"
import Img from "../../components/Img/Img";
import boothLogo from "../../images/booth.png";
import twitterLogo from "../../images/twitter.png";

const Casts1 = () => {
  const data = useStaticQuery(graphql`
    query {
      allCastsJson {
        edges {
          node {
            name
            twitter
            booth
            thumbnail {
              childImageSharp {
                fluid(maxWidth: 640) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `)

  const casts = data.allCastsJson.edges
  return (
    <div class="casts-wrapper">
      {casts.map(e => (
        <div className="cast-container">
          <div className="cast-image-wrapper">
            <Img src={e.node.thumbnail.childImageSharp.fluid.src} className="cast-image" />
          </div>
          <div className="cast-information-container">
            <h2 className="cast-information-name">{e.node.name}</h2>
            <div className="cast-information-links">
              <Link className="cast-information-twitter" to={e.node.twitter} target="_blank">
                <Img src={twitterLogo} className="cast-information-twitter-logo"/>
              </Link>
              <Link className="cast-information-booth" to={e.node.booth} target="_blank">
                <Img src={boothLogo} className="cast-information-booth-logo"/>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Casts1;